import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function PlusIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'TextDarkGrey', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13 11V3h-2v8H3v2h8v8h2v-8h8v-2h-8z", fill: primaryFillColor }) }));
}
//# sourceMappingURL=Plus.js.map